import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import RestrictedProductList from "../../components/RestrictedProduct";

const RestrictedProductPage = (): ReactElement => {
  return (
    <Layout>
      <RestrictedProductList />
    </Layout>
  );
};

export default RestrictedProductPage;
